import { LineChartData } from "Components/Charts/Line/Line";
import { useSelector } from "react-redux";
import {
  selectDashboardInspectionSubmissionWeeklyOutcomes,
  selectDashboardInspectionSubmissionWeeklyOutcomesLoading,
} from "Redux/Dashboard/slice";

export const useDashboard = () => {
  const inspectionSubmissionOutcomes = useSelector(
    selectDashboardInspectionSubmissionWeeklyOutcomes,
  );
  const loading = useSelector(
    selectDashboardInspectionSubmissionWeeklyOutcomesLoading,
  );
  
  const data: LineChartData[] = [
    {
      title: "Count of passed",
      data: inspectionSubmissionOutcomes.data.map(
        (inspection) => inspection.passed_count,
      ),
      itemColor: "rgba(238, 53, 41, 1)",
      areaColor: ["rgba(238, 53, 41, 1)", "rgba(238, 53, 41, 0)"],
    },
    {
      title: "Failed items",
      itemColor: "rgba(255, 138, 0, 1)",
      areaColor: ["rgba(255, 138, 0, 0.5)", "rgba(255, 138, 0, 0)"],
      data: inspectionSubmissionOutcomes.data.map(
        (inspection) => inspection.failed_count,
      ),
    },
  ];
  return { data, loading };
};
